import { openDB } from 'idb';
import { ToolboxTalkPayload } from '../types';

const DB_NAME = 'function-checks';
const OUTBOX_STORE = 'toolbox-outbox';
const CHECK_OUTBOX_STORE = 'outbox';

type ToolboxOutboxRecord = {
  id?: number;
  queuedAt: string;
  payload: ToolboxTalkPayload;
};

async function getDb() {
  return openDB(DB_NAME, 2, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(CHECK_OUTBOX_STORE)) {
        db.createObjectStore(CHECK_OUTBOX_STORE, { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(OUTBOX_STORE)) {
        db.createObjectStore(OUTBOX_STORE, { keyPath: 'id', autoIncrement: true });
      }
    }
  });
}

export async function addToolboxToOutbox(payload: ToolboxTalkPayload): Promise<number> {
  const db = await getDb();
  const id = await db.add(OUTBOX_STORE, { payload, queuedAt: new Date().toISOString() });
  return id as number;
}

export async function readToolboxOutbox(): Promise<ToolboxOutboxRecord[]> {
  const db = await getDb();
  return db.getAll(OUTBOX_STORE) as Promise<ToolboxOutboxRecord[]>;
}

export async function removeToolboxFromOutbox(id: number): Promise<void> {
  const db = await getDb();
  await db.delete(OUTBOX_STORE, id);
}
